module.exports = __webpack_public_path__ + "static/media/1 Train-AP_Z1.cc6b5a4d.png";